import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid place-items-center items-center md:h-screen mt-5 md:mt-0" }
const _hoisted_2 = { class: "col-span-12 md:col-span-5 md:w-5/12" }
const _hoisted_3 = { class: "bg-white shadow-md rounded-xl overflow-hidden lg:m-10" }
const _hoisted_4 = { class: "bg-gray-50 p-5" }
const _hoisted_5 = { class: "px-5 py-3" }
const _hoisted_6 = { class: "flex flex-col my-4" }
const _hoisted_7 = { class: "text-[12px] font-[600]" }
const _hoisted_8 = { class: "bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Redefinir senha",
                en: "Redefine password",
              })), 1)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submitEmail()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "email-input",
                type: "text",
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                placeholder: 
                  _ctx.$t('labels.generic', {
                    pt: 'Digite o seu e-mail',
                    en: 'Enter your email',
                  })
                ,
                class: _normalizeClass(_ctx.v$.form.email.$error ? 'p-invalid' : '')
              }, null, 8, ["modelValue", "placeholder", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.form.email.$errors
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("password.label")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              type: "button",
              label: 
                _ctx.$t('labels.generic', {
                  pt: 'Retornar ao login',
                  en: 'Return to login',
                })
              ,
              class: "btn-simple",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go.redirectTo('sign-in')))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              type: "submit",
              label: _ctx.$t('labels.generic', { pt: 'Enviar', en: 'Send' }),
              class: "btn-primary",
              disabled: false,
              loading: _ctx.loading
            }, null, 8, ["label", "loading"])
          ])
        ], 32)
      ])
    ])
  ]))
}